"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var LayoutContext_1 = require("../../Common/LayoutContext");
var enums_1 = require("../../Common/utils/enums");
var TwoFactorAuthenticationStrings_1 = __importDefault(require("../TwoFactorAuthenticationStrings"));
var VerifyAccountContext_1 = __importDefault(require("../VerifyAccountContext"));
var GetHelp_1 = __importDefault(require("./GetHelp"));
var MfaAutoSendFailed = function (_a) {
    var sendCode = _a.sendCode, initialChannel = _a.initialChannel;
    var _b = React.useContext(LayoutContext_1.LayoutContext), primaryAction = _b.primaryAction, secondaryAction = _b.secondaryAction;
    var setChannel = React.useContext(VerifyAccountContext_1["default"]).setChannel;
    var isSecondarySubmitting = secondaryAction && secondaryAction.isSubmitting;
    var sendEmail = function () {
        sendCode(enums_1.TwoFactorChannels.Email);
        if (typeof setChannel === 'function') {
            setChannel(enums_1.TwoFactorChannels.Email);
        }
    };
    var sendSMS = function () {
        sendCode(enums_1.TwoFactorChannels.SMS);
        if (typeof setChannel === 'function') {
            setChannel(enums_1.TwoFactorChannels.SMS);
        }
    };
    React.useEffect(function () {
        if (primaryAction.isSubmitting) {
            if (initialChannel === enums_1.TwoFactorChannels.Email) {
                sendEmail();
            }
            else {
                sendSMS();
            }
        }
        if (secondaryAction && secondaryAction.isSubmitting) {
            sendEmail();
        }
    }, [primaryAction.isSubmitting, isSecondarySubmitting]);
    return (React.createElement(design_language_1.StackChildren, null,
        React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageSubtext, textAlign: design_language_1.Text.TextAlignments.Center }, TwoFactorAuthenticationStrings_1["default"].weTriedToSendYouCode()),
        React.createElement(design_language_1.InlineChildren, { justifyContent: design_language_1.InlineChildren.Justification.Center },
            React.createElement(design_language_1.Stack, { size: design_language_1.Stack.Sizes.Large },
                React.createElement(GetHelp_1["default"], { isLink: true, isInline: true })))));
};
exports["default"] = MfaAutoSendFailed;
